// Module 0 · m0-3 — a small, dismissible "finish setting up" banner shown in the app shell until the
// tenant is activated. Self-contained + FAIL-SAFE: any error (including the 403 a non-owner/GM gets,
// since GET /api/setup/checklist is roles.manage@global) renders nothing, so it can never block the app.
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useApi } from '../contexts/ApiContext'
import { fetchSetupChecklist } from '../api/setup'

export function SetupNudge() {
  const api = useApi()
  const [show, setShow] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    let cancelled = false
    const run = async () => {
      try {
        const state = await fetchSetupChecklist(api)
        if (!cancelled) setShow(!state.activated)
      } catch {
        if (!cancelled) setShow(false) // fail-safe: the nudge never blocks the app
      }
    }
    void run()
    return () => { cancelled = true }
  }, [api])

  if (!show || dismissed) return null

  return (
    <div style={styles.bar} role="status">
      <span style={styles.text}>Finish setting up your restaurant to get to first service.</span>
      <span style={styles.actions}>
        <Link to="/setup" style={styles.link}>Continue setup →</Link>
        <button type="button" aria-label="Dismiss setup reminder" style={styles.close} onClick={() => setDismissed(true)}>×</button>
      </span>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  bar: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem',
    padding: '0.6rem 1rem', background: '#eff6ff', borderBottom: '1px solid #bfdbfe',
    fontFamily: 'system-ui, sans-serif', fontSize: 14, color: '#1e3a8a',
  },
  text: { minWidth: 0 },
  actions: { display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0 },
  link: { color: '#2563eb', fontWeight: 600, textDecoration: 'none', whiteSpace: 'nowrap' },
  close: { border: 'none', background: 'transparent', fontSize: 18, lineHeight: 1, color: '#64748b', cursor: 'pointer', padding: '0 0.25rem' },
}
